/*
 * Project: Goalscape
 * File:    App.js
 * Path:    src/App.js
 * Description: Main application component that sets up routing and authentication.
 * Author:  Akmal Djumakhodjaev
 * Created: [Creation Date - YYYY-MM-DD]
 * Modified: 2025-03-15
 * AI Hint: Consider implementing server-side rendering for improved SEO and initial load time.
 */
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import ProjectPage from './components/ProjectPage';
import Navbar from './components/Navbar';
import styled from 'styled-components';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import UserProfilePage from './pages/UserProfilePage'; // Import UserProfilePage

const AppContainer = styled.div`
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
`;

const MainContent = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
`;

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContainer>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/*" element={
              <PrivateRoute>
                <>
                  <Navbar />
                  <MainContent>
                    <Routes>
                      <Route path="/" element={<Dashboard />} />
                      <Route path="/ideas" element={<Dashboard />} /> {/* Route for Ideas/Plan */}
                      <Route path="/project/:id/card/:cardId" element={<ProjectPage />} />
                      <Route path="/project/:id" element={<ProjectPage />} />
                      <Route path="/profile/:userId" element={<UserProfilePage />} /> {/* Add UserProfilePage route */}
                    </Routes>
                  </MainContent>
                </>
              </PrivateRoute>
            } />
          </Routes>
        </AppContainer>
      </Router>
    </AuthProvider>
  );
}

export default App;